export const localStorageUserType = {
    dater:'dater',
    friend:'friend'
}

export const localStorageKeys = {
    userType:'userType',
    accessToken:'accessToken',
    mobileNumber: 'mobileNumber',
    profileId:'profileId',
    isLoggedIn:'isLoggedIn'
}

export const useLocalStorage = () =>{
    const setLocalStorageItem = (itemKey, itemValue)=>{
        localStorage.setItem(itemKey, itemValue);
    }
    const getLocalStorageItem = (itemKey) => {
        return localStorage.getItem(itemKey)
    }
    const removeLocalStorageItem = (itemKey) =>{
        localStorage.removeItem(itemKey)
    }

    return {
        setLocalStorageItem,
        getLocalStorageItem,
        removeLocalStorageItem
    }
}